import React from 'react';
import { useSelector } from 'react-redux';

const CustomTotal = (from, to, size) => {

const {userSettings} = useSelector(state => state.userSettingsReducer);
const getUserLanguage = () => {
  return userSettings.language ? userSettings.language : 'en';
}

const translateLine=() =>{
  const language= getUserLanguage();
  if (language==="es"){
    return  ` Mostrando ${from} a ${to} de ${size} resultados`
  }else if (language==="pt"){
    return ` Mostrando ${from} a ${to} de ${size} resultados`
  }else 
    return ` Showing ${from} to ${to} of ${size} results`
}
  return (
    <span className="react-bootstrap-table-pagination-total">
      {translateLine()}
    </span>
  );
}
export default CustomTotal